import {RequestError} from "../Types";

/**
 * serialize function used for async action errors,
 * since the default function from Redux Toolkit strips useful info from axios errors
 */
export const serializeAxiosError = (error: any) : RequestError => {
  return {...error.response?.data};
};
